module.exports = __webpack_public_path__ + "img/two-Items.30482539.png";